<template>
  <div></div>
</template>
<script>
export default {
  name: "logout",
  async created() {
    this.$store.dispatch("setJWT", { jwt: undefined }).then(() => {
      this.$router.push({
        path: "/login"
      });
    });
  }
};
</script>
